<section class="edp-side-steps d-flex flex-column flex-md-row">
    <div class="side-container">
        <div class="side-steps">
            <edp-steps-progress [step]="active.step" [steps]="stepsNumber"></edp-steps-progress>
        </div>

        <div class="side-content">
            <div class="side-content-header">
                <span class="side-step-title" [innerHTML]="active.title | translate"></span>
                <ng-container *ngIf="!!active.subtitle">
                    <span class="side-step-title" [innerHTML]="active.subtitle | translate"></span>
                </ng-container>
            </div>
        </div>

        <ng-container *ngIf="!!active.backButton">
            <div class="d-none d-md-flex align-items-center justify-content-center previous">
                <ng-container *ngTemplateOutlet="previousTemplate"></ng-container>
            </div>
        </ng-container>
    </div>

    <section>
        <ng-content></ng-content>
    </section>
</section>

<ng-container *ngIf="!!active.backButton">
    <div id="previous-mobile" class="container-previous-mobile d-block d-md-none">
        <ng-container *ngTemplateOutlet="previousTemplate"></ng-container>
    </div>
</ng-container>

<ng-template #previousTemplate>
    <a class="btn-previous" (click)="backStep.emit()">
        <i class="btn-previous-icon icon-edponline-Bop-073 rotate-90" aria-hidden="true"></i>
        <span class="ml-2 btn-previous-text">
            {{ 'pt.edp.edponline.resquests-and-operations.previous' | translate }}
        </span>
    </a>
</ng-template>
